import { ApiError } from "./client.js";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000";

function readCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

async function putJson(path, body) {
  const csrfToken = readCookie("business_csrf");
  const res = await fetch(`${API_URL}${path}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
    credentials: "include",
    body: JSON.stringify(body),
  });
  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await res.json().catch(() => null) : null;
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}

async function getJson(path) {
  const res = await fetch(`${API_URL}${path}`, { credentials: "include" });
  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await res.json().catch(() => null) : null;
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}

async function postJson(path, body) {
  const csrfToken = readCookie("business_csrf");
  const res = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
    credentials: "include",
    body: JSON.stringify(body ?? {}),
  });
  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await res.json().catch(() => null) : null;
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}

export const businessData = {
  getProfile: () => getJson("/api/business/profile"),
  putProfile: (data) => putJson("/api/business/profile", data),
  getCatalogs: () => getJson("/api/business/catalogs"),
  putCatalogs: (data) => putJson("/api/business/catalogs", data),
  getProjects: () => getJson("/api/business/projects"),
  putProjects: (data) => putJson("/api/business/projects", data),
  getEstimates: () => getJson("/api/business/estimates"),
  putEstimates: (data) => putJson("/api/business/estimates", data),
};

export const billingApi = {
  getStatus: () => getJson("/api/business/billing/status"),
  checkoutPlan: (plan) => postJson("/api/business/billing/checkout", { plan }),
  checkoutOveragePack: () => postJson("/api/business/billing/checkout-overage"),
};
